import React, { useEffect, useState } from "react";
import { Grid, Typography, Box, IconButton } from "@mui/material";
import { transformData, transformStockData } from "utils/transformdata";
import Product from "features/Category/categoryProd/components/Product";
import LoadingSmallCard from "components/ui/Skeleton/LoadingSmallCard";
import { useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as Filter } from "assets/filter/filter.svg";
import { ReactComponent as Sort } from "assets/icons/sort.svg";

const ReorderStockViewPage = () => {
  const [items, setItems] = useState([]);
  // const [title, setTitle] = useState("");
  const [loading, setLoading] = useState(true);

 
  const navigate = useNavigate();
  const location = useLocation();
  // const title = location.state?.name?.[0] || localStorage.getItem("reorderStockViewTitle");
  const title =
    sessionStorage.getItem("reorderStockViewTitle") || "Stock View";
  useEffect(() => {
    const data = sessionStorage.getItem("reorderStockViewData");
    if (data) {
      const parsed = JSON.parse(data);

      setItems(parsed);
    }

    setLoading(false);
  }, []);

 useEffect(() => {
  return () => {
    sessionStorage.removeItem("reorderStockViewData");
    sessionStorage.removeItem("reorderStockViewTitle");
  };
}, []);


  if (loading) return <LoadingSmallCard count={6} />;



  return (

    <Box sx={{ padding: "20px", paddingBottom: "15px", paddingTop: "15px", paddingLeft: "20px", paddingRight: "20px" }}>
      <div style={{
        display: "flex", alignItems: "center",
        justifyContent: "space-between", marginBottom: "25px"
      }}>
        <div>
          <Typography
            sx={{

              fontFamily: "Poppins",
              fontSize: "24px",
              color: "#fff",
              gap: "10px",

              fontWeight: "400",
              lineHeight: "36px",
              letterSpacing: "0px",
            }}
          >
            {title}
          </Typography>
        </div>

        <div >
          <IconButton disableRipple disableFocusRipple>
            <Filter />
          </IconButton>
          <IconButton disableRipple disableFocusRipple>
            <Sort />
          </IconButton>
        </div>
      </div>

      {items.map((data) => {

        const mapped = {
          _id: data._id || null,

          styleNumber: data.styleNumber || data.StyleCode || "",
          //    designClass: data.designClass || data.designClass ,
          designClass: data.designClass?.toLowerCase(),


          imageUrl:
            data.image?.transformedImageUrl ||
            data.imageUrl ||
            "",

          Orgimg:
            data.image?.imageUrl ||
            data.Orgimg ||
            "",

          image: {
            imageUrl:
              data.image?.imageUrl ||
              data.Orgimg ||
              "",

            transformedImageUrl:
              data.image?.transformedImageUrl ||
              data.imageUrl ||
              "",
          },

          images: [
            {
              imageUrl:
                data.image?.imageUrl ||
                data.Orgimg ||
                "",

              transformedImageUrl:
                data.image?.transformedImageUrl ||
                data.imageUrl ||
                "",
            },
          ],

          netWt: data.netWt || data.NetWt || 0,
          grossWt: data.grossWt || data.GrossWt || 0,

          weight:
            (data.netWt || data.NetWt) && (data.grossWt || data.GrossWt)
              ? `${data.netWt || data.NetWt} g / ${data.grossWt || data.GrossWt} g`
              : "",

          diaWt: data.diaWt || data["Dia Wt"] || 0,
          diaPcs: data.diaPcs || data["Dia Pc"] || 0,
          diaQlty: data.diaQlty || data.DiaQlty || "-",

          diamond: `${data.diaWt ?? data["Dia Wt"] ?? 0} Ct / ${data.diaPcs ?? data["Dia Pc"] ?? 0
            } Pcs`,

          csWt: data.csWt || data["CS Wt"] || 0,
          csPcs: data.csPcs || data["CS Pc"] || 0,

          colorStoneWeight: data.csWt || data["CS Wt"] || 0,
          colorStonePcs: data.csPcs || data["CS Pc"] || 0,

          otherWt: data.otherWt || data["Other Metal Wt"] || 0,
          otherPcs: data.otherPcs || data["Other Metal Pc"] || 0,

          otherMaterialWeight: data.otherWt || data["Other Metal Wt"] || 0,
          otherMaterialPcs: data.otherPcs || data["Other Metal Pc"] || 0,

          goldQlty: data.goldQlty || data.GoldQlty || "",

          goldColor:
            data.goldColor === "P" || data.GoldColor === "P"
              ? "Pink"
              : data.goldColor === "Y" || data.GoldColor === "Y"
                ? "Yellow"
                : data.goldColor === "W" || data.GoldColor === "W"
                  ? "White"
                  : data.goldColor || data.GoldColor || "",

          goldQuality: `${data.goldQlty || data.GoldQlty || ""} - ${data.goldColor || data.GoldColor || ""
            }`,

          itemSize: data.itemSize || data.itemSize || "N/A",

          makeDate: data.makeDate || data.MakeDate || null,

          date:
            data.makeDate || data.MakeDate
              ? new Date(data.makeDate || data.MakeDate).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })
              : "",

          location: data.location || "",
          status: data.status || data.Status || "On Hand",

          jewelId: data.jewelId || data.JewelId || null,
          jewelCode: data.jewelCode || data.JewelCode || "",

          sales: data.sales || 0,
          stockCount: data.stockCount || 0,
        };

        return (

          <Product
            sx={{ mt: 55 }}
            product={mapped}
            key={data._id}
            allData={items}
          />
        );
      })}

      {items.length === 0 && (
        <Typography
          sx={{
            fontFamily: "Poppins",
            color: "#888",
            textAlign: "center",
            mt: 10,
            fontSize: "16px",

          }}
        >
          No stock items found.
        </Typography>
      )}
    </Box>
  );
};

export default ReorderStockViewPage;